module.exports = __webpack_public_path__ + "img/icon-hal-en.2119bfc4.svg";